export const LISTE_ECHEANCES = {
  table: {
    number: 'N° de commande',
    commercial: 'Commercial(e)',
    payeur: 'Payeur',
    patrimoine: 'Patrimoine(s)',
    typeProduit: 'Type(s) produit',
    multiProduit: 'Multi-produits',
    multiPatrimoine: 'Multi-patrimoines',
    annonceur: 'Annonceur(s)',
    dateDebut: 'Date début',
    dateFin: 'Date de fin',
    montantHt: 'Montant HT',
    datePrev: 'Date prév. de facturation',
    codeDossier: 'Code dossier',
    agence: 'Agence',
    childrow: {
      commentaireFacturation: 'Commentaire de facturation :',
    },
  },
  actions: {
    filtre: 'Filtre',
    facturer: 'Facturer',
    search: 'Rechercher',
    export: 'Exporter',
    groupFacture: 'Grouper en une facture',
    echeancesAnterieurs: 'Afficher les échéances antérieures non facturées ({number})',
    masquer: 'Masquer les échéances antérieures non facturées',
  },
  filtre: {
    title: 'Filtre',
    commercial: 'Commercial',
    assistant: 'Assistant',
    sousTitle: 'Les filtres seront appliqués à la liste',
    typeProduit: 'Type produit',
    categorieVente: 'Catégorie de vente',
    code: 'N° de commande',
    codeDossier: 'Code dossier',
    dateCommande: 'Date de commande',
    datePremierAffichage: 'Date de campagne',
    enseigne: 'Enseigne(s)',
    indexe: 'Indexé',
    interne: 'Commande interne',
    annonceur: 'Annonceur(s)',
    patrimoine: 'Patrimoine',
    produits: 'Produit(s)',
    payeur: 'Payeur(s)',
    groupe: 'Groupe(s)',
    tags: 'Tags',
    agence: 'Agence(s)',
    theme: 'Thème',
    facturationFaite: 'Facturée',
    parutions: 'Parutions',
    regleFacturation: 'Règle(s) de facturation',
    estSigne: 'Signée',
    estSigneElectroniquement: 'Signée électroniquement',
    estIndexable: 'Indexé',
    etats: 'Etat(s)',
    codeCommande: 'Code commande',
    dateCampagne: 'Date de campagne',
    estinterne: 'Interne',

    actions: {
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
  },
  factureParEmail: 'Facture par email',
};

export const FACTURER = {
  facturation: 'Facturation',
  date: 'Date de facturation',
  genererUneSeuleFacture: 'Emettre une seule facture',
  genererFactureZero: 'Générer les factures même si le montant est à 0',
  actions: {
    facturer: 'Facturer',
  },
  messages: {
    success: {
      multiEcheancesFacturees: '{nb} factures ont été générées avec succès.',
      echeanceFacturee: 'La facture a été générée avec succès.',
    },
    error: {
      unitPriceLessZero: 'Le prix d\'une des échéances à facturer est inférieur à 0',
      samePayer: 'Pour émettre une seule facture, les lignes d\'échéances doivent avoir le même payeur',
      sameAgence: 'Pour émettre une seule facture, les lignes d\'échéances doivent avoir la même agence',
      noRemise: 'Pour émettre une seule facture, il ne faut aucune ligne de remise',
      noMultiPayerInCommande: 'Pour émettre une seule facture, les commandes ne doivent pas avoir plusieurs payeurs',
      noMultiRoleInCommande: 'Pour émettre une seule facture, les commandes ne doivent pas avoir plusieurs rôles',
      noMultiRepresentativeInCommande: 'Pour émettre une seule facture, les commandes ne doivent pas avoir plusieurs mandataires',
      lineNotBillable: 'Au moins une des lignes n\'est pas facturable. Allez voir l\'onglet achat de la commande',
      dateOverlap: 'Impossible de facturer : une ou plusieurs lignes de ventes ont le même produit à des dates que se chevauchent',
      prospectNotAllowed: 'Impossible de facturer une commande avec un intervenant prospect',
      factureAmountLowerThanAcomptes: 'La première facture générée sur une commande doit être supérieure ou égale à la somme des factures d\'acomptes réglés de cette commande',
      lockedClient: 'L\'intervenant {nomCommercial} pour la commande {code} est Totalement bloqué',
      fusionEcheancierVenteInterne: 'Il y a au moins un échéancier groupée sur cette commande alors qu\'elle contient des ventes internes',
      draftPurchaseOrdreBrouillon: 'Impossible de facturer une commande de vente qui a au moins une commande d\'achat ou de vente interne liée à l\'état "Brouillon"',
      echeanceAlreadyBill: 'Au moins une des échéances sélectionnées a déjà été facturée',
      echeanceMontantNegatif: 'Au moins une des échéances sélectionnées a un montant négatif',
      normalBillAmountPositive: 'La facture ne peut pas être négative',

    },
  },
};

export const DATE = {
  dateTo: 'au',
  dateFrom: 'Du',
};
